function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "svg-fill-blue",
  d: "M14.55,17.74c0,0.52-0.42,0.94-0.94,0.94c-0.37,0-0.68-0.22-0.83-0.53h-1.29v0.53h-0.84v-0.53h-0.33v0.53 H9.49v-1.36h3.29c0.15-0.31,0.46-0.53,0.83-0.53C14.13,16.8,14.55,17.23,14.55,17.74z M21.67,21.7c0.19-0.23,0.27-0.53,0.22-0.82 c-0.77-4.32-4.92-7.45-9.88-7.45c-4.95,0-9.09,3.13-9.86,7.45c-0.05,0.29,0.03,0.59,0.22,0.82c0.19,0.23,0.47,0.36,0.77,0.36H20.9 C21.2,22.06,21.48,21.92,21.67,21.7z M12.01,15.43c3.44,0,6.47,1.92,7.57,4.62H4.46C5.55,17.35,8.58,15.43,12.01,15.43z  M16.85,6.95c0-2.67-2.17-4.85-4.85-4.85S7.15,4.28,7.15,6.95S9.33,11.8,12,11.8S16.85,9.63,16.85,6.95z M14.85,6.95 c0,1.57-1.28,2.85-2.85,2.85S9.15,8.52,9.15,6.95S10.43,4.11,12,4.11S14.85,5.38,14.85,6.95z"
}));

var SvgIconAdmin = function SvgIconAdmin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAdmin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_admin.ffd459e9.svg";
export { ForwardRef as ReactComponent };